/**
 * The lock drawing family — the ids `LockAnimation.vue` draws.
 *
 * The hub declares `settings.lock_type` on its `lock` class (and a two-vessel
 * subset on the electric strike's own class); a device saved before that keeps
 * its kind in its icon and name, which `lockKindOf` still reads.
 */
import { lockKindOf } from '../../devices/deviceWidgetTypes';
import { variantFromSetting, variantValues, type VariantFamily } from './types';

export const LOCK_VARIANTS: VariantFamily = {
  drawing: 'lock',
  settingKey: 'lock_type',
  title: ['Lock type', 'Vrsta ključavnice'],
  description: [
    'Which lock this is. The tile draws it, thrown or open with its state.',
    'Katera ključavnica je to. Ploščica jo nariše, zaprto ali odprto glede na stanje.',
  ],
  options: [
    { value: 'auto', icon: 'settings_suggest', label: ['Automatic', 'Samodejno'] },
    { value: 'cylinder', icon: 'vpn_key', label: ['Rotary cylinder', 'Vrtljivi cilinder'] },
    { value: 'strike', icon: 'sensor_occupied', label: ['Electric strike', 'Električno odpiralo'] },
  ],
  defaultValue: 'auto',
  resolve: (device) =>
    variantFromSetting(device.settings, 'lock_type', variantValues(LOCK_VARIANTS)) ?? lockKindOf(device),
};
